export default "__VITE_ASSET__DoAp0s58__"